import ProjectCard from 'services/project/ProjectCard';

class PartnerCard extends ProjectCard {
  constructor(project) {
    super(project);

    this.transactionBrowsingRequestStatus = project.transactionBrowsingRequestStatus;
    this.transactionsBrowsingPermission = project.transactionsBrowsingPermission;
    this.transactionBrowsingRequestMinutesToExpire = project.transactionBrowsingRequestMinutesToExpire;
  }
}

export default PartnerCard;
